import React, { useEffect, useState } from 'react'
import AddEditForm from '../../../sharedComponents/AddEditForm'
import { PencilIcon, TrashIcon } from '@heroicons/react/24/solid'
import Modal from 'react-modal';
import DeleteConfirm from '../../../sharedComponents/DeleteConfirm';
import { toast } from 'react-toastify';
import useManageWebsites from './useManageWebsites';
import useShipDate from '../shipDate/useShipDate';

const customStyles = {
    overlay: {
      zIndex: 1000,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      height: 'auto',
      width: '500px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

const items = [
  {
    title: 'Website Name',
    name: 'webName',
    type: 'text',
  },
  /* {
    title: 'Category',
    name: 'category',
    type: 'text',
  }, */
  {
    title: 'URL',
    name: 'url',
    type: 'text',
  },
  {
    title: 'Username',
    name: 'username',
    type: 'text',
  },
  {
    title: 'Password',
    name: 'password',
    type: 'text',
  },
  {
    title: 'Keyword 1',
    name: 'keyword1',
    type: 'text',
  },
  {
    title: 'Keyword 2',
    name: 'keyword2',
    type: 'text',
  },
  {
    title: 'Note',
    name: 'note',
    type: 'text',
  },
  {
    title: 'Add. Rate (e.g. 0.005)',
    name: 'websiteAdditionalRate',
    type: 'number',
  },
  {
    title: 'Add. Transaction Fee ฿',
    name: 'websiteAdditionalTransactionFee',
    type: 'number',
  },
];

const initialValue = {
  uuid: '',
  webName: '',
  category: '',
  url: '',
  username: '',
  password: '',
  keyword1: '',
  keyword2: '',
  note: '',
  websiteAdditionalRate: 0,
  websiteAdditionalTransactionFee: 0,
}
const WebsiteSetting = () => {

  const [mode, setMode] = useState('register')
  const [modalTitle, setModalTitle] = useState('Register Website Information')

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const [website, setWebsite] = useState(initialValue);

  const {
    websites,
    isLoading,
    error,
    addWebsite,
    editWebsite,
    deleteWebsite,
    refreshWebsites
  } = useManageWebsites();

  const {
    addShipDate
  } = useShipDate();

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setWebsite({...website, [name]: value})
  }

  const openForm = async (isEdit,id) => {
    if(isEdit){
      const websiteToEdit = websites.find(w => w.uuid === id);
      if(websiteToEdit) {
        // Normalize so note is always a string (API may omit it or return null)
        setWebsite({ ...websiteToEdit, note: websiteToEdit.note ?? '' });
        setModalTitle('Update Website Information');
        setMode('edit');
      }

    }else{
      setWebsite(initialValue)
      setMode('register')
      setModalTitle('Register Website Information')
    }
    setIsFormOpen(true);
  };

  const closeForm = () =>{
    setIsFormOpen(false);
  }

  const openConfirm = async (id) => {
    const websiteToDelete = websites.find(w => w.uuid === id);
    if(websiteToDelete) {
      setWebsite(websiteToDelete);
      setIsConfirmOpen(true)
    }
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  const handleRegisterWebsite = async () => {
    try {
        const returnResult = await addWebsite(website);
        if (returnResult) {
          toast.success('Website registered successfully!');
          closeForm();
        } else {
          toast.error(error);
        }
    } catch (err) {

    }
  };

useEffect(() => {
  toast.error(error);
}, [error]);

const handleUpdateWebsite = async () => {
  try {
    console.log('website setting');
    await editWebsite(website.uuid, website);
    toast.success('Website updated successfully!');
    closeForm();
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
    toast.error(errorMessage);
  }
};

const handleDeleteWebsite = async (id) => {
  try {
    await deleteWebsite(id);
    toast.success('Website deleted successfully!');
    closeConfirm();
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
    toast.error(errorMessage);
  }
};

  useEffect(() => {
    refreshWebsites();
  }, []);


  return (
    <div>
      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        style={customStyles}
        ariaHideApp={false}
      >
        <AddEditForm 
          items={items} 
          name={modalTitle} 
          data={website} 
          mode={mode}
          closeForm={closeForm}
          handleInputChange={handleInputChange}
          handleRegister={handleRegisterWebsite}
          handleUpdate={handleUpdateWebsite}
          stateValue={website}
        />
      </Modal>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm
          items={items}
          data={website}
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteWebsite}
        />
      </Modal>

        <div className="px-4 sm:px-6 lg:px-8">
          <div className="mt-4 flex flex-col">
            <div className='flex justify-between items-center mb-4'>
              <h2 className='text-5xl'>Website Setting</h2>
              <button onClick={()=> openForm(false, null)} className='bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded'>
                Add New Website
              </button>
            </div>
            <div className="overflow-y-auto shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" style={{ maxHeight: 'calc(100vh - 200px)' }}>
              <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50 sticky top-0 z-10">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        No
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Website Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        URL
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Username
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Password
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Note
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Add. Rate
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Add. Fee ฿
                      </th>
                     {/*  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Keyword 1
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Keyword 2
                      </th> */}
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {websites.map((website, index) => {
                      const {uuid,webName,category,url,username,password,keyword1,keyword2, note, websiteAdditionalRate, websiteAdditionalTransactionFee} = website
                      return <tr key={uuid}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {index + 1}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{webName}</td>
                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-6" >
                          <a href={url} title={url} target="_blank" className="text-indigo-600 hover:text-indigo-900">
                            {url && url.length > 30 ? url.substring(0,30) + "..." : url}
                          </a>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{username}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{password}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{note}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {websiteAdditionalRate > 0 ? <span className="text-orange-600 font-medium">+{websiteAdditionalRate}</span> : '-'}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {websiteAdditionalTransactionFee > 0 ? <span className="text-orange-600 font-medium">+{websiteAdditionalTransactionFee}฿</span> : '-'}
                        </td>
                        {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{keyword1}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{keyword2}</td> */}
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-0 text-right text-sm font-medium ">
                            <div className="flex items-center space-x-3">
                                <PencilIcon onClick={()=> openForm(true,uuid)} className='cursor-pointer flex items-center w-6 h-6 fill-green-600'/>
                                <TrashIcon onClick={()=> openConfirm(uuid)} className='cursor-pointer flex items-center w-6 h-6 fill-red-600'/>
                            </div>
                        </td>
                      </tr>
                    })}
                  </tbody>
              </table>
            </div>
          </div>
        </div>
    </div>
  )
}

export default WebsiteSetting


const styles = `
.loader {
    border: 4px solid rgba(245, 245, 245, 0.3);
    border-radius: 50%;
    border-top: 4px solid #000;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`;